import { render, staticRenderFns } from "./CvLanguages.vue?vue&type=template&id=cba01162&scoped=true"
import script from "./CvLanguages.vue?vue&type=script&lang=js"
export * from "./CvLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba01162",
  null
  
)

export default component.exports